import { FaCheckCircle, FaShieldAlt } from "react-icons/fa";
import { formatRupiah } from "../../utils/formatPrice";

export interface BenefitInfo {
  eligible: boolean;
  benefit_percent: number;
  benefit_amount: number;
  description: string | null;
}

export const BenefitBadge: React.FC<{ benefit: BenefitInfo; consultationPrice: number }> = ({
  benefit,
  consultationPrice,
}) => {
  if (!benefit.eligible) return null;

  const pct    = benefit.benefit_percent;
  const amount =
    benefit.benefit_amount > 0
      ? benefit.benefit_amount
      : Math.round((consultationPrice * pct) / 100);
    Math.round((consultationPrice * pct) / 100);

  const r   = 28;
  const circ = 2 * Math.PI * r;
  const dash = (pct / 100) * circ;

  return (
    <div className="mt-3 overflow-hidden rounded-2xl shadow-md bg-gradient-to-br from-emerald-500 to-teal-600 text-white">
      <div className="flex items-center gap-2 px-4 pt-3 pb-2">
        <FaShieldAlt className="text-white/80 text-sm" />
        <span className="text-xs font-semibold tracking-widest uppercase text-white/80">
          Benefit Asuransi
        </span>
      </div>

      <div className="flex items-center gap-5 px-4 pb-4">
        {/* <div className="relative flex-shrink-0 w-16 h-16">
          <svg className="w-full h-full -rotate-90" viewBox="0 0 64 64">
            <circle
              cx="32" cy="32" r={r}
              fill="none"
              stroke="rgba(255,255,255,0.2)"
              strokeWidth="6"
            />
            <circle
              cx="32" cy="32" r={r}
              fill="none"
              stroke="white"
              strokeWidth="6"
              strokeLinecap="round"
              strokeDasharray={`${dash} ${circ}`}
              style={{ transition: "stroke-dasharray 1s ease" }}
            />
          </svg>
          <span className="absolute inset-0 flex items-center justify-center text-sm font-bold">
            {pct}%
          </span>
        </div> */}

        <div className="flex-1 min-w-0">
          <p className="text-white font-bold text-base leading-tight">
            Ditanggung Asuransi
          </p>
          {/* <p className="text-white/80 text-xs mt-0.5">
            {benefit.description ?? `Konsultasi ditanggung ${pct}%`}
          </p> */}
          {/* <div className="mt-2 inline-flex items-center bg-white/20 rounded-full px-3 py-1">
            <span className="text-white font-semibold text-sm">
              Hemat {formatRupiah(amount)}
            </span>
          </div> */}
        </div>
      </div>

      <div className="bg-black/10 px-4 py-1.5 flex items-center gap-1.5">
        <FaCheckCircle className="text-white/70 text-xs" />
        <span className="text-white/70 text-xs">
          Benefit akan dikurangkan dari total pembayaran
        </span>
      </div>
    </div>
  );
};